import DesktopShortcuts from "./desktopShortcuts";
import Icon from "@portal/components/atoms/icons";
import { UserMenu } from "../UserMenu";
import { Menu as HeadlessMenu, MenuButton as HeadlessMenuButton } from "@headlessui/react";
import { ResponsiveMenu } from "./ResponsiveMenu";
import { FC } from "react";
import { INavBarProps } from "./types";
import SmallDeviceShortcuts from "./smallDeviceShortcuts";
import Search from "./search";
import { isAdvisor } from "@portal/helpers/session/portalRoleStrings";
import BankLogoButton from "./bankLogoButton";
import LoginButton from "./loginButton";
import SignOutButton from "./signOutButton";

const NavBar: FC<INavBarProps> = ({ session, centerId }) => {
  const isAdvisorAndNoImpersonation = isAdvisor(session.role) && !session.impersonatedUser?.customerNumber;

  return (
    <div className="container mx-auto">
      <HeadlessMenu as="div">
        <div className="flex justify-between px-3 md:px-0">
          <BankLogoButton centerId={centerId} />
          {!isAdvisorAndNoImpersonation && <DesktopShortcuts />}
          {!isAdvisorAndNoImpersonation ? (
            <div className="relative flex space-x-3 items-center">
              <Search />
              <div>
                {session ? (
                  <div className="flex py-2">
                    <UserMenu />
                  </div>
                ) : (
                  <div className="flex h-[50px] min-w-[75px] px-2">
                    <LoginButton centerId={centerId} />
                  </div>
                )}
              </div>
              <div className="flex">
                <HeadlessMenuButton className="group">
                  <div className="hidden group-data-[open]:flex flex-col mb-3 mr-1 hover:text-secondary">
                    <Icon name="xMarkIcon" />
                  </div>
                  <div className="flex flex-col group-data-[open]:hidden hover:text-secondary">
                    <Icon name="barsIcon" />
                    <div className="text-sm leading-none -mt-1">Meny</div>
                  </div>
                </HeadlessMenuButton>
              </div>
            </div>
          ) : (
            <SignOutButton />
          )}
        </div>
        {!isAdvisorAndNoImpersonation && <ResponsiveMenu />}
      </HeadlessMenu>
      <SmallDeviceShortcuts />
    </div>
  );
};

export default NavBar;
